import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { AlertParams, ErrorMessage } from '../../alert.interface';

@Injectable({ providedIn: 'root' })
export class AlertService {
  readonly DEFAULT_DURATION = 5e3;
  readonly LONGER_DURATION = 10e3;

  private readonly defaultSnackbarPosition: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
  };

  constructor(private snackbar: XpoSnackBar, private zone: NgZone) {}

  static multipleError: string = 'The process did not complete successfully due to the following errors.';
  warningTitle = 'Warning';
  successTitle = 'Success';
  errorTitle = 'An error ocurred';
  static errorBody = "";

  static deriveErrorMessage(error: HttpErrorResponse & ErrorMessage[]): { detailedMessage: string; message: string } {
    const errorData = error?.error?.error;
        let message = this.errorBody,
      detailedMessage = this.errorBody;

    if (error?.status && errorData?.message) {
      detailedMessage = errorData.message;
      switch (error.status) {
        case HttpStatusCode.BadRequest:
          detailedMessage = detailedMessage.split('|').join('\n');
          break;
      }
    }

    if (errorData?.moreInfo?.length) {
      detailedMessage = '';

      errorData.moreInfo.forEach((err: { message: string | string[]; }, index: number) => {
        const m = err.message?.includes('com.xpo.ltl') ? this.errorBody : err.message;

        detailedMessage += `Error ${index + 1} - ${m}${index < errorData?.moreInfo.length - 1 ? '\n' : ''}`;
      });

      message = this.multipleError;
      detailedMessage = detailedMessage ?? this.errorBody;
    }

    if (Array.isArray(error)) {
      detailedMessage = '';
      error.forEach((err, index) => {
        detailedMessage += `Error ${index + 1} - ${err.message ?? err.detailedErrors?.join('\n')}${
          index < error.length - 1 ? '\n' : ''
        }`;
      });
      message = error.length > 1 ? this.multipleError : message;
      detailedMessage = detailedMessage ?? this.errorBody;
    }

    return { message, detailedMessage };
  }

  showApiError({ body, title, error }: AlertParams): void {
    const derived = AlertService.deriveErrorMessage(<HttpErrorResponse & ErrorMessage[]>error);

    body = body ?? derived.detailedMessage;
    title = title ?? derived.message;

    // Prevent showing a snackbar if both title and body are missing or empty
    if (!body?.trim() && !title?.trim()) {
      return;
    }

    this.zone.run(() => {
      this.snackbar.error(body ?? '');
    });
  }

//TODO: may need a parser for this
  showApiSuccess(successMessage: string) {
    this.zone.run(() => {
      this.snackbar.success(
         successMessage ?? ''
      )
  });
  }
}
